<template>
  <v-data-table item-key="id" :headers="headers" :items="permissions" class="elevation-1">
    <template v-slot:top>

      <v-toolbar flat color="white">
        <v-toolbar-title>Permission</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on">Add Permission</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="12">
                    <v-text-field v-model="editedItem.name" label="Name" placeholder="eg. (Create User,Delete User)"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <!-- <template v-slot:item.action="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
      <v-icon small @click="deleteItem(item)">delete</v-icon>
    </template> -->
    <template v-slot:no-data>
      <span class="text-center">No data available.</span>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapGetters,mapState } from "vuex";
import {slice,orderBy} from "lodash";

export default {
  data: () => ({
    dialog: false,
    dialogVerify: false,
    headers: [
      {
        text: "Name",
        align: "left",
        sortable: false,
        value: "name"
      }
      // ,
      // { text: "Actions", value: `action`, sortable: false }
    ],
    permissions:[],
    userLogin:{},
    editedIndex: -1,
    editedItem: {
      name: "",
    },
    defaultItem: {
      name: "",
    },
  }),

  computed: {
    ...mapGetters({
      getPermissions: "role_permission/getPermissions",
    }),
    formTitle() {
      return this.editedIndex === -1 ? "New Permission" : "Edit Permission";
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    ...mapActions({
      createPermission: "role_permission/addPermissions",
      deletePermission: "role_permission/deletePermissions"
    })
    ,
    async initialize() {
      const getPermissions = await this.getPermissions;
      this.userLogin = JSON.parse(window.localStorage.getItem('user_data'));
      this.permissions = orderBy(getPermissions,['id'],['asc'])
    }, 
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    async save() {
      if (this.editedIndex > -1) {        
        try{
          const response = await this.createPermission(this.editedItem)
          this.editedItem.role = this.roles.find(role => role.id === this.editedItem.role.id)
          Object.assign(this.item_users[this.editedIndex], this.editedItem)
        }catch(e){
          console.log(e)
        }
      } else {
        const response = await this.createPermission(this.editedItem)
        this.permissions.splice(this.permissions.length, 0, this.editedItem);
      }
      this.close();
    },
    async deleteItem(item){
      const index = this.permissions.indexOf(item);
      let result = confirm("Are you sure you want to delete?");
      if(result){  
        await this.deletePermission(item.id);
        this.permissions.splice(index,1)
      }
    }
  }
};
</script>